"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuoteLinkProperty = exports.quoteLinkPropertyDefinition = void 0;
exports.quoteLinkPropertyDefinition = {
    view: {
        label: 'Author',
        hint: 'Link quote to an Artist, Athlete, Photographer or Judge',
    },
    constraints: [
        {
            name: 'stencils',
            argument: [
                'artist',
                'athlete',
                'judge',
                'photographer',
            ],
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'quote-link',
};
const isQuoteLinkProperty = (prop) => {
    return prop.name === exports.quoteLinkPropertyDefinition.name;
};
exports.isQuoteLinkProperty = isQuoteLinkProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVvdGUtbGluay5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3F1b3RlLWxpbmsucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSwyQkFBMkIsR0FBRztJQUN6QyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsUUFBUTtRQUNmLElBQUksRUFBRSx5REFBeUQ7S0FDaEU7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRTtnQkFDUixRQUFRO2dCQUNSLFNBQVM7Z0JBQ1QsT0FBTztnQkFDUCxjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxZQUFZO0NBQ2EsQ0FBQTtBQUkxQixNQUFNLG1CQUFtQixHQUFHLENBQUMsSUFBa0IsRUFBNkIsRUFBRTtJQUNuRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssbUNBQTJCLENBQUMsSUFBSSxDQUFBO0FBQ3ZELENBQUMsQ0FBQTtBQUZZLFFBQUEsbUJBQW1CLHVCQUUvQiJ9